import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import addOrUpdate from './add-or-update';
import { ruleListFn, ruleFn as _ruleFn } from 'api/approval/config';
export default {
  components: {
    addOrUpdate: addOrUpdate
  },
  data: function data() {
    return {
      pageSizes: [100, 50, 20],
      page: {
        list: [],
        currPage: 1,
        limit: 20,
        total: 0
      },
      isAddOrUpdate: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 260;
    }
  }),
  mounted: function mounted() {
    this.getTableList();
  },
  methods: {
    getTableList: function getTableList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return ruleListFn({
                page: _this.page.currPage,
                size: _this.page.limit
              });
            case 2:
              res = _context.sent;
              _this.$emit('clear-loading');
              if (res && res.code === 1) {
                _this.page.list = res.data.result;
                _this.page.total = res.data.count;
                _this.$nextTick(function () {
                  if (_this.$refs.table) {
                    _this.$refs.table.doLayout && _this.$refs.table.doLayout();
                  }
                });
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 每页条数
    sizeChangeHandle: function sizeChangeHandle(val) {
      this.page.limit = val;
      this.getTableList();
    },
    // 切换 页
    currentChangeHandle: function currentChangeHandle(val) {
      this.page.currPage = val;
      this.getTableList();
    },
    addOrUpdateFn: function addOrUpdateFn(item) {
      var _this2 = this;
      this.isAddOrUpdate = true;
      this.$nextTick(function () {
        return _this2.$refs.addOrUpdate.init(item);
      });
    },
    ruleFn: function ruleFn(item, type) {
      var _this3 = this;
      // 1619 是否确认删除该假期
      // 1620 是否确认停用该假期
      // 1621 是否确认启用该假期
      var warnArr = new Map([[3, this.$t('1619')], [2, this.$t('1620')], [1, this.$t('1621')]]);
      this.$confirm(warnArr.get(type), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        _ruleFn({
          id: item.id,
          type: type
        }).then(function (res) {
          if (res && res.code === 1) {
            _this3.getTableList();
            _this3.$message.success(res.message);
          }
        });
      });
    }
  }
};